import { getStorage, setStorage } from '@/utils/storage'

const state = () => ({
  token: getStorage('token'),
  userInfo: getStorage('userInfo')
})

const getters = {
  token: (state) => state.token,
  userInfo: (state) => {
    const userInfo = state.userInfo
    if (userInfo) {
      if (typeof state.userInfo === 'object') return userInfo
      else return JSON.parse(userInfo)
    } else return {}
  }
}

const mutations = {
  setToken (state, token) {
    state.token = token
    setStorage('token', token)
  },
  setUserInfo (state, userInfo) {
    state.userInfo = userInfo
    setStorage('userInfo', JSON.stringify(userInfo))
  }
}

const actions = {
  setToken ({ commit }, value) {
    commit('setToken', value)
  },
  setUserInfo ({ commit }, value) {
    commit('setUserInfo', value)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js